var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-wrapper"},[_c('header',{staticClass:"header"},[_c('div',{staticClass:"container"},[_c('router-link',{attrs:{"to":_vm.homePath,"exact":""}},[_c('img',{attrs:{"src":require("../assets/img/logo.png"),"alt":"","width":"113","height":"54"}})])],1)]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }